import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export class LidoFacilities {
  organizationId: number;
  hasSwimCoursesChild: boolean;
  hasSwimCoursesAdult: boolean;
  hasYogaPilates: boolean;
  hasAquaGym: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LidoFacilitiesService {

  constructor(private _http: HttpClient) { }


  /**
   * submitCourse
   */
  public submitFacility(orgId: string, facility: string, status: number) {
    const object = {
      'id': orgId,
    };
    object[facility] = status;
    console.log(object);
    return this._http
      .post<string>(
        environment.serverUrl + 'facility/saveLidoFacilities',
        object
      ).pipe(
        map(responseData => {
          return responseData;
        }),
        catchError(errorRes => {
          return throwError(errorRes);
        })
      );
  }

  /**
   * getLidoFacilitiesByOrgId
   */
  public getLidoFacilitiesByOrgId(orgId: number) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', orgId.toString());
    return this._http.get<LidoFacilities>(environment.serverUrl + 'facility/getLidoFacilities', {
      params: paramas,
    }).pipe(
      map(responseData => {
        return responseData;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }
}
